export const cartMixin = {
	methods: {
		async loadCartData()
		{
			this.isLoadingCart = true;
			try
			{
				const response = await BX.ajax.runAction(
					'corsik:yadelivery.Checkout.Base.getBasketData',
				);

				if (response.status === 'success' && response.data)
				{
					this.cartData = response.data;
					this.showCartPanel = true;
				}
			}
			catch (error)
			{
				console.error('Failed to load cart data:', error);
			}
			finally
			{
				this.isLoadingCart = false;
			}
		},

		useCartData()
		{
			if (!this.cartData)
			{
				return;
			}

			const cartWeightGrams = Number(this.cartData.weight) || 0;

			const cartPrice = Number(this.cartData.price) || 0;

			this.orderPrice = String(cartPrice);
			this.orderWeight = String(cartWeightGrams / this.weightToGramsMultiplier);
			this.total.price = cartPrice;
			this.total.weight = cartWeightGrams;

			this.setTotalResult();
			this.showCartPanel = false;
			this.recalculateAddress();
		},
	},
};
